export default __webpack_public_path__ + "static/media/hero_background.b3e823aa.png";